var _style, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolkadotNewDotLogo = function SvgPolkadotNewDotLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "polkadot-new-dot-logo_svg__Logo",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1326.1 1410.3",
    style: {
      enableBackground: "new 0 0 1326.1 1410.3"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".polkadot-new-dot-logo_svg__st0{fill:#e6007a}")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "polkadot-new-dot-logo_svg__st0",
    cx: 663,
    cy: 147.9,
    rx: 254.3,
    ry: 147.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "polkadot-new-dot-logo_svg__st0",
    cx: 663,
    cy: 1262.3,
    rx: 254.3,
    ry: 147.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-60 180.499 426.56)",
    className: "polkadot-new-dot-logo_svg__st0",
    cx: 180.5,
    cy: 426.5,
    rx: 254.3,
    ry: 148
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-60 1145.575 983.768)",
    className: "polkadot-new-dot-logo_svg__st0",
    cx: 1145.6,
    cy: 983.7,
    rx: 254.3,
    ry: 147.9
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-30 180.45 983.72)",
    className: "polkadot-new-dot-logo_svg__st0",
    cx: 180.5,
    cy: 983.7,
    rx: 148,
    ry: 254.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-30 1145.522 426.601)",
    className: "polkadot-new-dot-logo_svg__st0",
    cx: 1145.6,
    cy: 426.6,
    rx: 147.9,
    ry: 254.3
  })));
};
export { SvgPolkadotNewDotLogo as ReactComponent };